import React, { useEffect, useState } from 'react';
import { TextField, Typography, Box, InputAdornment } from '@mui/material';
import { SmartFormStates } from './SmartForm';
import ErrorWrapper from '@component/ErrorWrapper';
import { syncValidatorResults } from "@component/smartForm/validatorUtils"

const SmartTextInput = ({
  field,
  label,
  value,
  onChange,
  isEdit,
  sx = {},
  valueSx = {},
  renderView,
  editable = true,
  validator,
  validatorResults,
  setValidatorResults,
  formState,
  startIcon,
  endIcon,
  helperText,
  ...props
}) => {
  const handleChange = (e) => {
    onChange(field, e.target.value);
  };

  const [showError, setShowError] = useState(false);
  const [validatorResult, setValidatorResult] = useState("");

  useEffect(() => {
    setShowError(formState === SmartFormStates.SAVING);
  }, [formState]);

  useEffect(() => {
    if (validator) {
      const validatorResult = validator(value);
      syncValidatorResults(validatorResults, setValidatorResults, !validatorResult, label);
      setValidatorResult(validatorResult);
    }
  }, [value, validator, setValidatorResults, validatorResults, label]);

  const renderViewMode = () => {
    if (renderView) {
      return renderView(value);
    }

    return (
      <>
        {label && (
          <Typography
            variant="caption"
            component="div"
            sx={{
              color: 'text.secondary',
              fontSize: '0.75rem',
              lineHeight: 1.66,
              mb: 0
            }}
          >
            {label}
          </Typography>
        )}

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {startIcon && (
            <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>{startIcon}</Box>
          )}
          <Typography
            variant="body1"
            sx={{
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              ...valueSx,
            }}
          >
            {value || '-'}
          </Typography>
          {endIcon && (
            <Box sx={{ ml: 1, display: 'flex', alignItems: 'center' }}>{endIcon}</Box>
          )}
        </Box>
      </>
    );
  };

  const renderEditMode = () => (
    <ErrorWrapper message={validatorResult} showMessage={showError}>
      <TextField
        label={label}
        value={value || ''}
        onChange={handleChange}
        fullWidth
        variant="outlined"
        helperText={helperText}
        sx={{
          '& .MuiInputBase-root': {
            mt: 0.75,
          },
        }}
        InputProps={{
          startAdornment: startIcon && (
            <InputAdornment position="start">
              {startIcon}
            </InputAdornment>
          ),
          endAdornment: endIcon && (
            <InputAdornment position="end">
              {endIcon}
            </InputAdornment>
          ),
        }}
        {...props}
      />
    </ErrorWrapper>
  );

  const renderContent = () => {
    if (!isEdit || !editable) {
      return renderViewMode();
    }
    return renderEditMode();
  };

  return (
    <Box sx={sx}>
      {renderContent()}
    </Box>
  );
};

export default SmartTextInput;